import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import classNames from "classnames";
import * as React from "react";
import Notification from "../notification/notification";

interface AutocompleteInputProps {
    values: string[];
    onInputChange: (event: any, value: any, reason: any) => void;
    errorMessage?: string;
    value: string;
    topLabel: string;
    onBlur: (event: any) => void;
    clearValidation: () => void;
    disabled?: boolean;
}


interface AutocompleteInputState {
    errorMessage: string;
}

export default class AutocompleteInput extends React.Component<AutocompleteInputProps, AutocompleteInputState> {
    public constructor(props: any) {
        super(props);

        this.state = {
            errorMessage: ""
        };
    }

    public render() {
        const errorMessage = !!this.props.errorMessage;
        return (
            <form autoComplete="off">
                <Autocomplete
                    value={this.props.value}
                    className="text-input autocomplete-input"
                    freeSolo
                    onBlur={(event) => {
                        this.props.onBlur(event);
                    }}
                    onInputChange={this.props.onInputChange}
                    options={this.props.disabled ? [] : this.props.values}
                    onKeyDown={(event) => {
                        if (event.key === "Enter") {
                            event.preventDefault();
                        } else {
                            this.props.clearValidation();
                        }
                    }}
                    disabled={this.props.disabled}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            autoComplete="cc-number"
                            fullWidth
                            margin="normal"
                            variant="outlined"
                            size="small"
                            inputProps={{
                                ...params.inputProps,
                                autoComplete: "off"
                            }}
                            label={this.props.topLabel}
                            InputLabelProps={{
                                shrink: true
                            }}
                            error={errorMessage}
                            helperText={this.getHelperText()}
                            className={classNames("text-input", { "disabled": this.props.disabled })}
                            disabled={this.props.disabled}
                        />
                    )}
                />
            </form>
        );
    }

    private getHelperText() {
        return (!!this.props.errorMessage ? <Notification type="error" message={this.props.errorMessage} /> : "");
    }
}
